// packages/content/src/strings/nature.ts
import type { StringBank } from '../schema/strings';
export default {
  apple: 'apple', orange: 'orange', pear: 'pear', peach: 'peach', cherry: 'cherry',
  cockle: 'cockle shell', cowrie: 'cowrie shell', scallop: 'scallop shell', sandDollar: 'sand dollar', conch: 'conch shell',
} as const satisfies StringBank;
